import {CreatePaymentIntentRequestBody, CreatePaymentIntentResponse} from 'types/orderTypes'
import {opsApi} from './apis'

export const createPaymentIntent = (payload: CreatePaymentIntentRequestBody) => {
  return opsApi.post<CreatePaymentIntentResponse>('wallet', payload)
}
